var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatGifsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 17",
    style: {
      enableBackground: "new 0 0 20 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9A33FF;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,17H5.1C2.3,17,0,14.7,0,11.9V5.1C0,2.3,2.3,0,5.1,0h9.7C17.7,0,20,2.3,20,5.1v6.7 C20,14.7,17.7,17,14.9,17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,5.6c0.3,0.1,0.4,0.5,0.3,0.8S7.3,6.8,7,6.7C6.7,6.5,6.4,6.5,6,6.5c-0.9,0-1.5,0.8-1.5,1.9s0.6,1.9,1.5,1.9 c0.4,0,0.8-0.2,1-0.5l0,0V9.1H6.6H6.5C6.2,9.1,6,8.9,6,8.6V8.5V8.4c0.1-0.3,0.3-0.5,0.5-0.6h0.1h1h0.1C8,7.8,8.2,8,8.2,8.3v0.1v1.5 V10l0,0v0.1v0.1l-0.1,0.2c-0.4,0.8-1.2,1.2-2.1,1.2c-1.7,0-2.8-1.4-2.8-3.1S4.4,5.4,6,5.4C6.6,5.4,7,5.5,7.5,5.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.2,6L11.2,6v4.9V11c0,0.3-0.3,0.5-0.6,0.5S10,11.3,10,11v-0.1V6.1V6c0-0.3,0.3-0.5,0.6-0.5 C10.9,5.5,11.2,5.7,11.2,6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,5.5h2l0,0c0.4,0.1,0.6,0.3,0.7,0.6c0,0.3-0.2,0.6-0.5,0.6h-0.1h-1.4v1.8h1.1h0.1C15.8,8.5,16,8.7,16,9 l0,0.2v0.1c0,0.3-0.3,0.4-0.6,0.4h-0.1h-1.1v1.1v0.1c0,0.3-0.2,0.5-0.5,0.5h-0.1h-0.1c-0.3,0-0.5-0.2-0.5-0.5v-0.1V6.1V6 C13,5.7,13.3,5.5,13.6,5.5h2H13.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGifsIcon);
export default __webpack_public_path__ + "static/media/chat_gifs_icon.305f37ae6800bb40ff5251b65fa7f4ff.svg";
export { ForwardRef as ReactComponent };